import { render, staticRenderFns } from "./PageMeusPedidos.vue?vue&type=template&id=071c2de0&scoped=true&"
import script from "./PageMeusPedidos.vue?vue&type=script&lang=js&"
export * from "./PageMeusPedidos.vue?vue&type=script&lang=js&"
import style0 from "./PageMeusPedidos.vue?vue&type=style&index=0&id=071c2de0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071c2de0",
  null
  
)

export default component.exports